/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `created` - created
 * * `pending` - pending
 * * `sent` - sent
 * * `received` - received
 * * `started` - started
 * * `success` - success
 * * `failure` - failure
 * * `revoked` - revoked
 * @export
 */
export const ThreediModelTaskStatusEnum = {
  CREATED: "created",
  PENDING: "pending",
  SENT: "sent",
  RECEIVED: "received",
  STARTED: "started",
  SUCCESS: "success",
  FAILURE: "failure",
  REVOKED: "revoked",
} as const;
export type ThreediModelTaskStatusEnum =
  (typeof ThreediModelTaskStatusEnum)[keyof typeof ThreediModelTaskStatusEnum];

export function instanceOfThreediModelTaskStatusEnum(value: any): boolean {
  for (const key in ThreediModelTaskStatusEnum) {
    if (Object.prototype.hasOwnProperty.call(ThreediModelTaskStatusEnum, key)) {
      if (ThreediModelTaskStatusEnum[key as keyof typeof ThreediModelTaskStatusEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ThreediModelTaskStatusEnumFromJSON(json: any): ThreediModelTaskStatusEnum {
  return ThreediModelTaskStatusEnumFromJSONTyped(json, false);
}

export function ThreediModelTaskStatusEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ThreediModelTaskStatusEnum {
  return json as ThreediModelTaskStatusEnum;
}

export function ThreediModelTaskStatusEnumToJSON(value?: ThreediModelTaskStatusEnum | null): any {
  return value as any;
}

export function ThreediModelTaskStatusEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): ThreediModelTaskStatusEnum {
  return value as ThreediModelTaskStatusEnum;
}
